import * as types from "./types";
import {
    getMetricsListAxios,
    deleteMetricAxios,
    postMetricAxios,
    putMetricAxios,
    getMetricByIDAxios
} from "./services";

export async function getMetricsListAction({ commit }) {
    commit(types.LOADING_METRICS, true);
    try {
        const { data } = await getMetricsListAxios();
        commit(types.GET_METRICS_LIST, data.result.data);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_METRICS, false);
    }
}

export async function removeMetricAction({ commit }, payload) {
    commit(types.LOADING_METRICS, true);
    try {
        await deleteMetricAxios(payload);
        commit(types.REMOVE_METRICS, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_METRICS, false);
    }
}

export async function addMetricAction({ commit }, payload) {
    commit(types.LOADING_METRICS, true);
    try {
        await postMetricAxios(payload);
        commit(types.ADD_METRICS, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_METRICS, false);
    }
}

export async function updateMetricAction({ commit }, payload) {
    commit(types.LOADING_METRICS, true);
    try {
        await putMetricAxios(payload);
        commit(types.UPDATE_METRICS, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_METRICS, false);
    }
}


export async function getMetricByIDAction({commit}, payload) {
    commit(types.LOADING_METRICS, true);
    try {
        
        const {data} = await getMetricByIDAxios(payload);
        commit(types.GET_METRICSBYID, data.result);
    }
    catch(e) {
        throw e;
    }
    finally {
        commit(types.LOADING_METRICS, false);
    }
   
}